import { useEffect, useRef } from 'react';

const useFetchGridDataWithPagination = (
  componentKey: string,
  firstPageRequest: any,
  restPagesRequest: any,
  pagination: any,
  changePage: (page: number) => void,
  size: number,
  vendorId?: number,
  currentPage?: number,
  searchTerm?: string,
  businessUnitId?: number,
) => {
  const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isInitialMount = useRef(true);

  /* get first page data on initial load and when vendor/businessUnit/size changes */
  useEffect(() => {
    changePage(1);
    firstPageRequest.run(size, 1, 0, vendorId, searchTerm, businessUnitId);
  }, [vendorId, size, businessUnitId])

  /* handle search with debounce - skip initial mount */
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      changePage(1);
      firstPageRequest.run(size, 1, 0, vendorId, searchTerm, businessUnitId);
    }, 300);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchTerm]);

  /* get rest of the pages data */
  useEffect(() => {
    if (
      pagination &&
      pagination[componentKey].length > 0 &&
      pagination.totalItems > pagination[componentKey].length * pagination.page
    ) {
      // const take = pagination.totalItems;
      const nextPage = currentPage;
      const offset = currentPage ? size * (currentPage - 1) : size;

      restPagesRequest.run(size, nextPage, offset, vendorId, searchTerm, businessUnitId);
    }
  }, [currentPage]);
};

export default useFetchGridDataWithPagination;
